const BASE_FILES_URL = (() => {
  const v = import.meta?.env?.VITE_REGISTER_DOCTOR_URL;
  return v && String(v).trim()
    ? String(v).trim().replace(/\/+$/, "")
    : "https://back.mediwave.tn";
})();

const normalizeText = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

const extractFullName = (u) => {
  if (!u) return null;
  const raw = u?.raw || {};
  const user = u?.user || raw?.user || {};
  const profile = u?.profile || raw?.profile || {};
  const candidates = [
    u?.fullName, raw?.fullName, user?.fullName, profile?.fullName,
    u?.displayName, raw?.displayName, user?.displayName,
    u?.name, raw?.name, user?.name,
  ];
  for (const candidate of candidates) {
    if (candidate && typeof candidate === "string" && candidate.trim().length > 1) return candidate.trim();
  }

  const firstNameVariants = [
    u?.firstName, raw?.firstName, user?.firstName, profile?.firstName,
    u?.prenom, raw?.prenom, user?.prenom, profile?.prenom,
  ];
  const lastNameVariants = [
    u?.lastName, raw?.lastName, user?.lastName, profile?.lastName,
    u?.nom, raw?.nom, user?.nom, profile?.nom,
  ];

  let firstName = null;
  let lastName = null;
  for (const first of firstNameVariants) {
    if (first && typeof first === "string" && first.trim().length > 0) { firstName = first.trim(); break; }
  }
  for (const last of lastNameVariants) {
    if (last && typeof last === "string" && last.trim().length > 0) { lastName = last.trim(); break; }
  }

  if (firstName && lastName) return `${firstName} ${lastName}`;
  if (firstName) return firstName;
  if (lastName) return lastName;

  const email = u?.email || raw?.email || user?.email;
  if (email && typeof email === "string" && email.includes("@")) return email.split("@")[0];
  return null;
};

const getInitialsFromUser = (user, fallback = "DR") => {
  const firstName = normalizeText(user?.firstName || user?.prenom || user?.user?.firstName || user?.user?.prenom || user?.profile?.firstName || user?.profile?.prenom);
  const lastName = normalizeText(user?.lastName || user?.nom || user?.user?.lastName || user?.user?.nom || user?.profile?.lastName || user?.profile?.nom);
  if (firstName || lastName) {
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase() || fallback;
  }
  const fullName = user?.fullName || user?.name || user?.displayName || user?.email?.split("@")?.[0] || "";
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return fallback;
};

const isValidAvatarSrc = (src) => {
  if (!src || typeof src !== "string") return false;
  const clean = src.trim();
  if (!clean) return false;
  const lower = clean.toLowerCase();
  const invalidPatterns = [
    "cdn-icons-png.flaticon.com/512/149/149071.png", "149071.png",
    "default-avatar", "default_avatar", "placeholder", "avatar-placeholder",
    "undefined", "null",
  ];
  return !invalidPatterns.some((pattern) => lower.includes(pattern));
};

const resolveAvatar = (rawAvatar) => {
  if (!rawAvatar) return null;
  const raw = String(rawAvatar).trim();
  if (!raw || raw.toLowerCase() === "undefined" || raw.toLowerCase() === "null") return null;
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalized = raw.replaceAll("\\", "/");
  const lower = normalized.toLowerCase();
  let idx = lower.indexOf("/uploads/");
  if (idx === -1) idx = lower.indexOf("uploads/");
  if (idx === -1) return null;

  let relative = normalized.slice(idx);
  if (!relative.startsWith("/")) relative = `/${relative}`;
  return `${BASE_FILES_URL}${relative}`;
};

export const buildDoctorDisplayData = (caseItem, currentDoctor = null, avatarOverride = null) => {
  const rawCase = caseItem?.raw || caseItem || {};
  const doctorSource = rawCase?.doctor || rawCase?.author || rawCase?.user || rawCase?.profile || caseItem?.author || currentDoctor || {};
  const fallbackSource = currentDoctor || {};

  const fullName = extractFullName(doctorSource) || extractFullName(fallbackSource) || "Dr. Unknown";
  const initials = getInitialsFromUser(doctorSource, "DR") || getInitialsFromUser(fallbackSource, "DR") || "DR";
  const avatarSrc = avatarOverride || resolveAvatar(
    doctorSource?.avatar ||
      doctorSource?.avatarUrl ||
      doctorSource?.photo ||
      doctorSource?.profileImage ||
      doctorSource?.image ||
      doctorSource?.raw?.avatar ||
      doctorSource?.raw?.avatarUrl ||
      fallbackSource?.avatar ||
      fallbackSource?.avatarUrl ||
      fallbackSource?.photo ||
      fallbackSource?.profileImage ||
      fallbackSource?.image ||
      null
  );

  return {
    name: fullName,
    initials,
    color: doctorSource?.color || "#c7d2fe",
    avatarSrc,
    hasAvatar: isValidAvatarSrc(avatarSrc),
  };
};
